import React from 'react';
import { Shield, Download, CheckCircle, ArrowRight, BookOpen, Gift, Lock } from 'lucide-react';
import { useLocalCurrency } from '../hooks/useLocalCurrency';
export function PurchaseSection() {
  const {
    formatPrice,
    countryFlag,
    currencyCode,
    isUSD,
    isLoading
  } = useLocalCurrency();
  return <section id="compra" className="py-20 bg-[#0C2818] text-white relative overflow-hidden" data-id="element-283">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,#16A34A_0%,#0C2818_70%)] opacity-40" data-id="element-284"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-285">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-[#FBBF24]" data-id="element-286">
          {/* Header */}
          <div className="bg-[#E63946] text-white p-6 text-center" data-id="element-287">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-wider" data-id="element-288">
              🎯 Acceso Inmediato
            </h2>
            <p className="text-red-100 mt-2 font-medium" data-id="element-289">
              Accedé hoy con precio promocional
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-290">
            {/* Superpack image composition - NOT clickable */}
            <div className="flex justify-center mb-8" data-id="element-291">
              <div className="relative w-[320px] h-[220px] md:w-[420px] md:h-[280px]" data-id="element-292">
                <img src="https://cdn.magicpatterns.com/uploads/eAavdGDwKT6TkE74KtW7RF/bono_4.png" alt="Bono 4" className="absolute w-24 md:w-32 rounded-md shadow-lg pointer-events-none" style={{
                left: '0%',
                top: '18%',
                transform: 'rotate(-12deg)',
                zIndex: 1
              }} data-id="element-293" />
                <img src="https://cdn.magicpatterns.com/uploads/daZk6Cr1WwNzg8bCz3Cf8H/bono_1.png" alt="Bono 1" className="absolute w-24 md:w-32 rounded-md shadow-lg pointer-events-none" style={{
                left: '8%',
                top: '8%',
                transform: 'rotate(-6deg)',
                zIndex: 2
              }} data-id="element-294" />
                <img src="https://cdn.magicpatterns.com/uploads/3NpYhKtd9rcmE2siPQ4GDy/bono_3.png" alt="Bono 3" className="absolute w-24 md:w-32 rounded-md shadow-lg pointer-events-none" style={{
                right: '0%',
                top: '18%',
                transform: 'rotate(12deg)',
                zIndex: 1
              }} data-id="element-295" />
                <img src="https://cdn.magicpatterns.com/uploads/nTd3oYn3NTFUuqvnhUmNru/bono_2.png" alt="Bono 2" className="absolute w-24 md:w-32 rounded-md shadow-lg pointer-events-none" style={{
                right: '8%',
                top: '8%',
                transform: 'rotate(6deg)',
                zIndex: 2
              }} data-id="element-296" />
                <img src="https://cdn.magicpatterns.com/uploads/1YUtJDJVs1ZKhrEJoXRy3i/1_COVER.png" alt="MegaPack Educación Física LISTA" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-36 md:w-48 rounded-lg shadow-2xl border-2 border-white pointer-events-none" style={{
                zIndex: 3
              }} data-id="element-297" />
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 md:w-64 md:h-64 rounded-full opacity-20" style={{
                background: 'radial-gradient(circle, #FBBF24 0%, transparent 70%)',
                zIndex: 0
              }} data-id="element-298" />
              </div>
            </div>

            {/* Value Stack */}
            <div className="bg-[#FAFAF7] rounded-xl p-6 mb-8 border border-[#F0EDE8]" data-id="element-299">
              <h3 className="text-lg font-black text-[#0C2818] mb-4 text-center uppercase tracking-wider" data-id="element-300">
                Todo lo que recibís hoy:
              </h3>
              <div className="space-y-3" data-id="element-301">
                <div className="flex items-center justify-between" data-id="element-302">
                  <div className="flex items-center gap-2" data-id="element-303">
                    <BookOpen className="w-5 h-5 text-[#16A34A]" data-id="element-304" />
                    <span className="font-semibold" data-id="element-305">
                      📘 MegaPack Educación Física LISTA™
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm" data-id="element-306">
                    {formatPrice(29.99)}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-307">
                  <div className="flex items-center gap-2" data-id="element-308">
                    <Gift className="w-5 h-5 text-[#FBBF24]" data-id="element-309" />
                    <span className="font-medium" data-id="element-310">
                      🎁 Bono 1 – Juegos de Patio y Gimnasio
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm" data-id="element-311">
                    {formatPrice(9.99)}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-312">
                  <div className="flex items-center gap-2" data-id="element-313">
                    <Gift className="w-5 h-5 text-[#FBBF24]" data-id="element-314" />
                    <span className="font-medium" data-id="element-315">
                      🎁 Bono 2 – Rúbricas y Evaluaciones
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm" data-id="element-316">
                    {formatPrice(9.99)}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-317">
                  <div className="flex items-center gap-2" data-id="element-318">
                    <Gift className="w-5 h-5 text-[#FBBF24]" data-id="element-319" />
                    <span className="font-medium" data-id="element-320">
                      🎁 Bono 3 – Actividades Espacios Reducidos
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm" data-id="element-321">
                    {formatPrice(9.99)}
                  </span>
                </div>
                <div className="flex items-center justify-between" data-id="element-322">
                  <div className="flex items-center gap-2" data-id="element-323">
                    <Gift className="w-5 h-5 text-[#FBBF24]" data-id="element-324" />
                    <span className="font-medium" data-id="element-325">
                      🎁 Bono 4 – Kit de Juegos Híper Práctico
                    </span>
                  </div>
                  <span className="text-gray-400 line-through text-sm" data-id="element-326">
                    {formatPrice(9.99)}
                  </span>
                </div>
                <div className="border-t border-gray-300 pt-3 mt-3 flex items-center justify-between" data-id="element-327">
                  <span className="font-black text-lg" data-id="element-328">Valor total:</span>
                  <span className="text-gray-400 line-through font-bold text-lg" data-id="element-329">
                    {formatPrice(69.95)}
                  </span>
                </div>
              </div>
            </div>

            {/* Price Display with Flag + Currency */}
            <div className="flex flex-col md:flex-row gap-8 items-center justify-between mb-8" data-id="element-330">
              <div className="space-y-3 flex-1" data-id="element-331">
                {['Descarga digital inmediata', 'Material imprimible y editable', 'Bonos incluidos', 'Compra segura'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-332">
                    <CheckCircle className="w-5 h-5 text-[#16A34A] flex-shrink-0" data-id="element-333" />
                    <span className="text-base font-medium text-gray-700" data-id="element-334">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="text-center bg-gradient-to-b from-green-50 to-white p-6 rounded-xl border-2 border-[#16A34A] min-w-[280px] shadow-lg" data-id="element-335">
                {/* Customer Count Badge */}
                <div className="mb-4" data-id="element-336">
                  <span className="bg-green-100 text-[#16A34A] text-xs font-bold px-3 py-1 rounded-full inline-block" data-id="element-337">
                    +3.200 docentes ya accedieron
                  </span>
                </div>

                {/* Flag + Label */}
                {!isLoading && <div className="mb-2" data-id="element-338">
                    <span className="text-3xl" data-id="element-339">{countryFlag}</span>
                    <p className="text-xs text-gray-500 font-medium mt-1" data-id="element-340">
                      Precio en tu moneda
                    </p>
                  </div>}

                {/* Strikethrough original price */}
                <p className="text-gray-500 text-base line-through mb-1" data-id="element-341">
                  Precio Regular: {formatPrice(47)}
                </p>
                <p className="text-[#E63946] text-lg font-bold mb-1" data-id="element-342">Hoy:</p>

                {/* Main price */}
                <p className="text-5xl md:text-6xl font-black text-[#0C2818] mb-2" data-id="element-343">
                  {formatPrice(13.99)}
                </p>

                <p className="text-[#16A34A] font-bold text-sm bg-[#16A34A]/10 py-1 px-4 rounded-full inline-block mb-2" data-id="element-344">
                  Pago único • Acceso de por vida
                </p>

                {/* Currency note */}
                {!isUSD && !isLoading && <p className="text-[10px] text-gray-400 mt-2 leading-tight" data-id="element-345">
                    Precio aproximado en {currencyCode} · El cobro final se
                    realiza en USD
                  </p>}
              </div>
            </div>

            {/* Primary CTA */}
            <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#16A34A] hover:bg-[#15803D] text-white font-black text-xl md:text-2xl py-5 px-6 rounded-xl text-center shadow-[0_0_40px_rgba(22,163,74,0.5)] hover:shadow-[0_0_50px_rgba(22,163,74,0.7)] transform hover:scale-[1.02] transition-all duration-300 mb-4" data-id="element-346">
              <span className="flex items-center justify-center gap-2" data-id="element-347">
                Acceder al MegaPack Educación Física LISTA™
                <ArrowRight className="w-6 h-6" data-id="element-348" />
              </span>
            </a>

            <p className="text-center text-sm text-gray-500 mb-8 font-medium" data-id="element-349">
              🔒 Pago 100% seguro · Garantía de 30 días · Datos protegidos con
              cifrado SSL
            </p>

            {/* Trust Badges */}
            <div className="grid grid-cols-3 gap-4 border-t border-gray-200 pt-8 mb-8" data-id="element-350">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-351">
                <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center" data-id="element-352">
                  <Shield className="w-6 h-6 text-[#16A34A]" data-id="element-353" />
                </div>
                <span className="font-bold text-xs md:text-sm" data-id="element-354">
                  Compra 100% Segura
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-355">
                <div className="w-12 h-12 bg-yellow-50 rounded-full flex items-center justify-center" data-id="element-356">
                  <Shield className="w-6 h-6 text-[#FBBF24]" data-id="element-357" />
                </div>
                <span className="font-bold text-xs md:text-sm" data-id="element-358">
                  Garantía 30 días
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-359">
                <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center" data-id="element-360">
                  <Download className="w-6 h-6 text-[#E63946]" data-id="element-361" />
                </div>
                <span className="font-bold text-xs md:text-sm" data-id="element-362">
                  Descarga inmediata
                </span>
              </div>
            </div>

            {/* Payment Methods & Security */}
            <div className="flex flex-col items-center gap-4 border-t border-gray-200 pt-6" data-id="element-363">
              <div className="flex flex-wrap justify-center gap-2" data-id="element-364">
                {['💳 Visa', '💳 Mastercard', '💳 Amex', '💳 PayPal', '💳 PIX'].map((method, i) => <span key={i} className="bg-gray-100 text-gray-600 text-xs font-medium px-3 py-1 rounded-md" data-id="element-365">
                    {method}
                  </span>)}
              </div>

              <div className="flex flex-col items-center gap-1" data-id="element-366">
                <div className="flex items-center gap-1.5 text-xs text-gray-400 font-medium" data-id="element-367">
                  <Lock className="w-3 h-3" data-id="element-368" />
                  <span data-id="element-369">Procesado de forma segura por Hotmart</span>
                </div>
                <div className="text-xs text-gray-400 font-medium" data-id="element-370">
                  🔐 Conexión cifrada SSL 256-bit
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee Section */}
        <div className="mt-12 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-371">
          <div className="w-20 h-20 bg-[#FBBF24] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg" data-id="element-372">
            <Shield className="w-10 h-10 text-white" data-id="element-373" />
          </div>
          <h3 className="text-2xl font-bold mb-3" data-id="element-374">
            Garantía de satisfacción 30 días
          </h3>
          <p className="text-gray-300 mb-6" data-id="element-375">
            Descargás el material. Lo revisás. Si no se adapta a tu realidad
            docente, pedís el reembolso. Sin preguntas.
          </p>
          <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#C62828] text-white font-black text-lg py-3 px-8 rounded-full shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-376">
            Comprar sin riesgo
            <ArrowRight className="w-5 h-5" data-id="element-377" />
          </a>
        </div>
      </div>
    </section>;
}